var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"w-100 h-100 d-flex justify-center align-center",attrs:{"color":"transparent"}},[_c('v-btn',{attrs:{"color":_vm.value ? 'success' : 'error',"small":"","icon":""},on:{"click":function($event){return _vm.btnClickedHandler()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.value ? 'mdi-check' : 'mdi-close'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }